import { render, staticRenderFns } from "./Fallas.vue?vue&type=template&id=208a368d&"
import script from "./Fallas.vue?vue&type=script&lang=js&"
export * from "./Fallas.vue?vue&type=script&lang=js&"
import style0 from "./Fallas.vue?vue&type=style&index=0&id=208a368d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports